import React from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import Button from "../Button";
import MainTariffDescription from "../MainTariffDescription";
import { LazyImage } from "react-lazy-images";
import { replaceStaticHost, webpTransformer } from "Helpers/ImageManager";
import ExclusiveV2 from "../ExclusiveV2";
import TextItem from "../TextItem";
import TariffDetailsBlock from "../TariffDetailsBlock";
import MasterNow from "../MasterNow";
import { sendMetriks } from "Services/sendMetriks";
import { SVGTime, SVGArrowDownMini, SVGArrowUpMini } from "Constants/SVG";

const useStyles = createUseStyles((theme) => ({
	root: {
		display: "flex",
		flexDirection: "column",
		gap: "12px",
		backgroundColor: theme.palette.colors.white,
		border: "1px solid #DCE0E9",
		borderRadius: "20px",
		padding: "16px",
	},
	descriptionWrapper: {
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "space-between",
	},
	exclusiveWrapper: {
		display: "flex",
		gap: "4px",
	},
	buttonWrapper: {
		width: "100%",
		display: "flex",
		gap: "16px",
	},
	test: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
	},
	img: {
		height: "30px",
		width: "auto",
	},
	[`@media (max-width: ${theme.media.tariffsSmall})`]: {
		img: {
			maxWidth: "calc(100% - 234px)",
			objectFit: "contain",
		},
	},
}));

const TariffCardV2 = (props) => {
	const {
		data,
		isOpen,
		onClick,
		onClickConnect,
		buttonConnectComponent,
		master_text,
		hit_text,
		exclusive_text_1,
		month_text,
		free_text,
		with_discount_text,
		discount_to_text,
		speed_new_text,
		first_month_with_discount_text,
		servicesHomeInternet_text,
		channels_text,
		tv_text,
		tv_channels_text,
		sim_card_text,
		gb_text,
		min_text,
		first_month_free_text,
		free_to_text,
	} = props;
	const classes = useStyles();

	const clickButton = () => {
		!!onClickConnect && onClickConnect();
		sendMetriks("NEW_OPEN_CONNECT_TARIFF");
	};

	const onClickDetails = () => {
		if (isOpen) {
			sendMetriks("CLOSE_DETAILS_NEW_TARIFF");
			onClick();
		} else {
			sendMetriks("OPEN_DETAILS_NEW_TARIFF");
			onClick();
		}
	};

	let image = (
		<LazyImage
			src={
				!!webpTransformer
					? webpTransformer(replaceStaticHost(data.provider.logo_2))
					: replaceStaticHost(data.provider.logo_2)
			}
			placeholder={({ ref }) => <img ref={ref} className={classes.img} alt={data.provider.name} />}
			actual={({ imageProps }) => (
				<img {...imageProps} className={classes.img} alt={data.provider.name} />
			)}
		/>
	);

	let channels = data.tv?.channels + data.tv?.channels_hd;
	let isFreeCost = data.price?.license_fee_month === 0 ? true : false;
	let dateEnd = new Date(data?.after?.rule?.date_end);
	let dateActionEnd = dateEnd?.toLocaleString("ru-RU", {
		day: "numeric",
		month: "long",
	});

	return (
		<div className={classes.root}>
			<div className={classes.descriptionWrapper}>
				<div>
					<div className={classes.exclusiveWrapper}>
						{data.is_exclusive ? <ExclusiveV2>{hit_text}</ExclusiveV2> : ""}
						{isFreeCost ? (
							data?.after?.rule?.month_cnt === 1 ? (
								<ExclusiveV2 color="purple">{first_month_free_text}</ExclusiveV2>
							) : data?.after?.rule?.date_end ? (
								<ExclusiveV2 color="purple">
									{free_to_text} {dateActionEnd}
								</ExclusiveV2>
							) : (
								<ExclusiveV2 color="purple">
									{exclusive_text_1} {data?.after?.rule?.month_cnt} {month_text} {free_text}
								</ExclusiveV2>
							)
						) : (
							""
						)}
						{!isFreeCost && data?.after?.rule?.date_end ? (
							<ExclusiveV2 color="purple">
								{discount_to_text} {dateActionEnd}
							</ExclusiveV2>
						) : (
							""
						)}
						{data?.after?.rule?.month_cnt && !isFreeCost ? (
							<ExclusiveV2 color="purple">
								{data?.after?.rule?.month_cnt === 1
									? `${first_month_with_discount_text}`
									: `${exclusive_text_1} ${data?.after?.rule?.month_cnt} ${month_text}. ${with_discount_text}`}
							</ExclusiveV2>
						) : (
							""
						)}
					</div>

					{data.internet ? (
						<MainTariffDescription
							num={data.internet.speed_in}
							unit={speed_new_text}
							description={servicesHomeInternet_text}
							exclusive={data.is_exclusive || isFreeCost || data?.after?.rule?.date_end}
						/>
					) : (
						""
					)}

					{!data.internet && channels ? (
						<MainTariffDescription
							num={channels}
							unit={channels_text}
							description={tv_text}
							exclusive={data.is_exclusive || isFreeCost || data?.after?.rule?.date_end}
						/>
					) : (
						""
					)}
				</div>

				{image}
			</div>
			{data.internet ? (
				<div>
					{channels ? <TextItem description={`${tv_channels_text} ${data.tv.channels}`} /> : ""}
					{data.mobile_new?.internet ? (
						<TextItem
							description={`${sim_card_text} ${data.mobile_new.internet && data.mobile_new.internet !== 0 && data.mobile_new.internet} ${gb_text}, ${data.mobile_new.calls && data.mobile_new.calls !== 0 && data.mobile_new.calls} ${min_text}`}
						/>
					) : (
						""
					)}
				</div>
			) : (
				""
			)}

			{isOpen && (
				<TariffDetailsBlock
					name={data.name}
					provider_name={data.provider.name}
					connection_price={data.connection.price}
					calculation_connect={data.price.system_calculation_connect}
					exclusives_name={data?.exclusives?.name}
					mobile={data?.mobile_new}
					sms={data?.mobile_new?.sms}
					router={data.dody[0].short_description}
					tvbox={data.dody[1].short_description}
					action={data.dody[4].short_description}
					description={data.dody[2].short_description}
					unlim={data?.social_unlim}
				/>
			)}
			<div className={classes.buttonWrapper}>
				<div className={classes.test}>
					<Button
						connectButton
						status="purple"
						secondaryButton
						fullWidth
						onClick={() => clickButton()}
					>
						{buttonConnectComponent}
					</Button>

					{data.provider.provider_settings.tariffs?.button_text?.includes("сегодня") && (
						<MasterNow svg={SVGTime} text={master_text} />
					)}
				</div>
				<Button circle36 grayBorder onClick={onClickDetails}>
					{isOpen ? (
						<svg
							width="8"
							height="6"
							viewBox="0 0 8 6"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d={SVGArrowUpMini} fill="#6B7280" />
						</svg>
					) : (
						<svg
							width="8"
							height="6"
							viewBox="0 0 8 6"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d={SVGArrowDownMini} fill="#6B7280" />
						</svg>
					)}
				</Button>
			</div>
		</div>
	);
};

TariffCardV2.propTypes = {
	data: PropTypes.object,
	isOpen: PropTypes.bool,
	onClick: PropTypes.func,
	onClickConnect: PropTypes.func,
	master_text: PropTypes.string,
	hit_text: PropTypes.string,
	exclusive_text_1: PropTypes.string,
	month_text: PropTypes.string,
	free_text: PropTypes.string,
	with_discount_text: PropTypes.string,
	discount_to_text: PropTypes.string,
	speed_new_text: PropTypes.string,
	servicesHomeInternet_text: PropTypes.string,
	channels_text: PropTypes.string,
	tv_text: PropTypes.string,
	tv_channels_text: PropTypes.string,
	sim_card_text: PropTypes.string,
	first_month_with_discount_text: PropTypes.string,
	first_month_free_text: PropTypes.string,
	free_to_text: PropTypes.string,
};

export default TariffCardV2;
